module.exports = __webpack_public_path__ + "img/tick-white.c4d3b739.svg";